import * as t from 'io-ts';
import { BWQuerySystem } from '@bayer-int/portletce-shared';

import type { SelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface BWSystemSettingDefinition extends SelectDefinition {
    key: 'BW_SYSTEM';
}

const definition: BWSystemSettingDefinition = {
    type: 'Select',
    key: 'BW_SYSTEM',
    label: 'BW system',
    options: Object.values(BWQuerySystem).map(val => ({ key: val, label: val })),
    value: 'H2R',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const BWSystemSettingDefinition = define({
    key: 'BW_SYSTEM',
    label: 'BW system',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.BWsystem),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.BWsystem),
});
